<template>
    <div>
        <div class="page-content px-4 top">
            <template-breadcrumb v-if="isDataLoaded" :title="details.title" />
            <template-header v-if="isDataLoaded" :title="details.title" />
            <b-card footer-class="p-0" class="rounded-lg">
                <div class="profile-details">
                    <form>
                        <input type="hidden" name="id" :value="templateId" />
                    </form>

                    <b-row class="skeleton" v-if="!isDataLoaded">
                        <b-col md="4" class="content">
                            <div class="smaller"></div>
                            <div class="smaller"></div>
                            <div></div>
                            <div></div>
                            <div class="smaller"></div>
                        </b-col>
                        <b-col md="4" class="content">
                            <div></div>
                            <div></div>
                            <div class="smaller"></div>
                            <div></div>
                            <div class="smaller"></div>
                        </b-col>
                        <b-col md="4" class="content">
                            <div class="smaller"></div>
                            <div class="smaller"></div>
                            <div></div>
                            <div></div>
                            <div class="smaller"></div>
                        </b-col>
                    </b-row>

                    <b-row v-else-if="isDataLoaded">
                        <b-col lg="6">
                            <b-form-group
                                label-for="title"
                                label-cols="3"
                                label="Title:"
                            >
                                <b-input
                                    v-if="isEditMode"
                                    id="title"
                                    v-model="editDetails.title"
                                    :class="{
                                        'border-danger': errors.has('title')
                                    }"
                                    v-validate="'required'"
                                    name="title"
                                    type="text"
                                    placeholder="Title (required)"
                                    :disabled="isSavingEdit"
                                />
                                <b-input
                                    v-else
                                    plaintext
                                    :value="details.title"
                                />
                            </b-form-group>
                            <b-form-group
                                label-for="purchaseOrder"
                                label-cols="3"
                                label="Type:"
                            >
                                <b-input plaintext value="Purchase Order" />
                            </b-form-group>
                            <b-form-group
                                label-for="supplier"
                                label-cols="3"
                                label="Supplier:"
                                :class="{ 'custom-flex': !isEditMode }"
                            >
                                <vet-select
                                    v-if="isEditMode"
                                    module="supplier"
                                    placeholder="Select supplier (optional)"
                                    v-model="editDetails.supplier"
                                    :disabled="isSavingEdit"
                                    show-actions
                                />
                                <div v-else>
                                    <a href="#" v-if="details.supplier">
                                        {{ details.supplier.label }}
                                    </a>
                                    <span v-else></span>
                                </div>
                            </b-form-group>
                        </b-col>
                        <b-col lg="6">
                            <b-form-group
                                label-for="description"
                                label-cols="3"
                                label="Description:"
                            >
                                <b-textarea
                                    v-if="isEditMode"
                                    v-model="editDetails.description"
                                    name="description"
                                    placeholder="Description (optional)"
                                    :disabled="isSavingEdit"
                                />
                                <b-input
                                    v-else
                                    plaintext
                                    :value="details.description"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <template v-slot:footer no-body>
                    <b-tabs card class="list" lazy>
                        <b-tab title-link-class="p-0">
                            <template v-slot:title>
                                <b-nav-item-dropdown :popper-opts="popperOpt">
                                    <template slot="button-content">
                                        <i class="cus-page-white-text"></i>
                                        <b>Items</b>
                                    </template>
                                    <b-dropdown-item @click="reloadItems">
                                        <i class="cus-page-white-text"></i>
                                        View Items
                                    </b-dropdown-item>
                                    <div class="dropdown-divider"></div>
                                    <b-dropdown-item @click="addNewItem">
                                        <i class="cus-add"></i>
                                        Add Item
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>
                            </template>
                            <b-card-text>
                                <div class="table-responsive">
                                    <LoaderList v-if="isLoadingItems" />
                                    <b-table-simple
                                        v-else
                                        borderless
                                        :hover="
                                            items.length > 0 && !isRowDragging
                                        "
                                        class="list"
                                    >
                                        <b-thead>
                                            <b-tr>
                                                <b-th style="width: 30px;" />
                                                <b-th>Item:</b-th>
                                                <b-th>Quantity:</b-th>
                                                <b-th>Notes:</b-th>
                                                <b-th></b-th>
                                            </b-tr>
                                        </b-thead>
                                        <b-tbody v-if="items.length === 0">
                                            <b-tr>
                                                <b-td colspan="5">
                                                    <i>No records available</i>
                                                </b-td>
                                            </b-tr>
                                        </b-tbody>
                                        <draggable
                                            v-else
                                            v-model="items"
                                            tag="tbody"
                                            ghost-class="sort-row-ghost"
                                            drag-class="sort-row-drag"
                                            :animation="0"
                                            @start="isRowDragging = true"
                                            @end="isRowDragging = false"
                                            @sort="itemsSorted"
                                        >
                                            <tr
                                                v-for="(item, index) in items"
                                                :key="index"
                                            >
                                                <td style="cursor: move;">
                                                    <i
                                                        class="cus-black-white-swatch"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="hidden"
                                                        name="record_id"
                                                        :value="item.id"
                                                    />
                                                    <input
                                                        type="hidden"
                                                        name="item_id"
                                                        :value="item.item_id"
                                                    />

                                                    <a
                                                        v-if="item.item"
                                                        href="#"
                                                        @click.prevent="
                                                            editItem(item)
                                                        "
                                                    >
                                                        {{ item.item.name }}
                                                    </a>
                                                    <span v-else>-</span>
                                                </td>
                                                <td>
                                                    {{ item.quantity }}
                                                    {{ item.uom_label }}
                                                </td>
                                                <td>
                                                    {{ item.note }}
                                                </td>
                                                <td class="text-right">
                                                    <b-dropdown
                                                        size="sm"
                                                        variant="link"
                                                        right
                                                        no-caret
                                                    >
                                                        <template
                                                            v-slot:button-content
                                                        >
                                                            <i
                                                                class="cus-cog-down"
                                                            />
                                                        </template>
                                                        <b-dropdown-item
                                                            @click="
                                                                editItem(item)
                                                            "
                                                        >
                                                            <i
                                                                class="cus-page-white-edit"
                                                            />
                                                            Edit Item
                                                        </b-dropdown-item>
                                                        <b-dropdown-item
                                                            @click="
                                                                deleteItem(
                                                                    item.id
                                                                )
                                                            "
                                                        >
                                                            <i
                                                                class="cus-delete"
                                                            />
                                                            Delete Item
                                                        </b-dropdown-item>
                                                    </b-dropdown>
                                                </td>
                                            </tr>
                                        </draggable>
                                    </b-table-simple>
                                </div>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </template>
            </b-card>
        </div>

        <modal-item ref="modalItem" @reload="fetchDataElements" />
        <modal-delete-item ref="modalDeleteItem" @reload="fetchDataElements" />
    </div>
</template>

<script>
import VetSelect from "@/module/commons/vet-select";
import ModalItem from "@/components/commons/modal-item";
import ModalDeleteItem from "@/components/commons/modal-delete-item";
import LoaderList from "@/components/elements/loader-list";
import TemplateHeader from "@/module/settings/template/header.vue";
import TemplateBreadcrumb from "@/module/settings/template/breadcrumb.vue";
import draggable from "vuedraggable";
import TEMPLATES from "@/constants/templates";
import SettingTemplateMixin from "@/mixins/settings-template";

export default {
    mixins: [SettingTemplateMixin],
    components: {
        VetSelect,
        ModalItem,
        LoaderList,
        draggable,
        ModalDeleteItem,
        TemplateHeader,
        TemplateBreadcrumb
    },
    data() {
        return {
            templateId: null,
            isDataLoaded: false,
            isLoadingItems: true,
            isRowDragging: false,
            popperOpt: {
                placement: "bottom-start",
                modifiers: {
                    flip: {
                        enabled: false
                    }
                },
                positionFixed: true
            }
        };
    },
    computed: {
        details: {
            get() {
                return this.$store.state.settingsTemplate.details;
            },
            set(value) {
                this.$store.commit("settingsTemplate/setDetails", value);
            }
        },
        editDetails: {
            get() {
                return this.$store.state.settingsTemplate.editDetails;
            },
            set(value) {
                this.$store.commit("settingsTemplate/setEditDetails", value);
            }
        },
        isEditMode: {
            get() {
                return this.$store.state.settingsTemplate.isEditMode;
            }
        },
        isSavingEdit() {
            return this.$store.state.settingsTemplate.isSavingEdit;
        },
        items: {
            get() {
                return this.$store.state.settingsTemplate.items;
            },
            set(value) {
                this.$store.commit("settingsTemplate/setItems", value);
            }
        }
    },
    watch: {
        "editDetails.supplier"(supplier) {
            if (supplier && supplier.value) {
                this.onSelectSupplier(supplier.value);
            } else {
                this.editDetails.sourceCatalog = null;
            }
        },
        "editDetails.title"(title) {
            this.editDetails.name = title;
        }
    },
    mounted() {
        this.fetchData();

        this.$store.commit(
            "settingsTemplate/setTemplateType",
            TEMPLATES.TYPE.PURCHASE_ORDER
        );
    },
    beforeDestroy() {
        // clear vuex store
        this.$store.dispatch("settingsTemplate/reset");
    },
    methods: {
        errorClass(key) {
            return {
                "border-danger": this.errors.has(key)
            };
        },
        async fetchData() {
            try {
                this.isDataLoaded = false;
                let encodedTemplateId = this.$route.params.id;

                // fetch details
                let fetchDetails = await this.$http.get(
                    `${process.env.BARRAMUNDI}account/template/${encodedTemplateId}?encoded=true`
                );

                let {
                    name,
                    description,
                    id,
                    source_catalog: sc,
                    supplier,
                    type
                } = fetchDetails.data.response.resources;

                // fix source_catalong result "null" as string
                // bugfix: if supplier is null, source catalog force set to null
                if (sc === "null" || !supplier) {
                    sc = null;
                }

                // apply details
                this.templateId = id; // plain id
                this.details = fetchDetails.data.response.resources;
                this.details.id = id;
                this.details.type = type;
                this.details.title = name;
                this.details.description = description;
                this.details.sourceCatalog = sc;

                // supplier
                if (supplier) {
                    this.details.supplier = {
                        label: supplier.name,
                        value: supplier.id
                    };
                }

                this.isDataLoaded = true;

                this.validateTemplateType(
                    this.details.type,
                    TEMPLATES.TYPE.PURCHASE_ORDER
                );

                // fetch uom
                await this.$store.dispatch("references/getUOM", {
                    module: true
                });

                // fetch elements
                await this.fetchDataElements();

                // store templateId in vuex
                this.$store.commit("settingsTemplate/setTemplateId", this.templateId); // prettier-ignore
            } catch (error) {
                console.log(error);
                this.isDataLoaded = true;
                this._message(error.message, "danger");
            }
        },
        reloadItems() {
            this.fetchDataElements();
        },
        async fetchDataElements() {
            this.isLoadingItems = true;

            // fetch items
            let fetchElements = await this.$http.get(
                `${process.env.BARRAMUNDI}account/purchase-order-element?template_id=${this.templateId}`
            );

            if (
                fetchElements.data &&
                fetchElements.data.response &&
                fetchElements.data.response.resources
            ) {
                let items = fetchElements.data.response.resources;

                for (let item of items) {
                    if (item.item) {
                        if (item.item.unit) {
                            item.uom_label = item.item.unit; // integrated supplier
                        } else if (item.item.uom) {
                            item.uom_label = this.getUOM(item.item.uom); // non-integrated supplier
                        }
                    } else {
                        item.uom_label = "";
                    }
                }

                this.items = items;
            } else {
                this.items = [];
            }

            this.isLoadingItems = false;
        },
        addNewItem() {
            this.$refs.modalItem.open({
                mode: "ADD",
                module: "TEMPLATE",
                templateId: this.templateId,
                sourceCatalog: this.details.sourceCatalog
            });
        },
        deleteItem(elementId) {
            this.$refs.modalDeleteItem.open(elementId);
        },
        editItem(item) {
            this.$refs.modalItem.open({
                mode: "EDIT",
                module: "TEMPLATE",
                elementId: item.id,
                itemName: item.item ? item.item.name : "-",
                itemId: item.item_id,
                note: item.note,
                sourceCatalog: this.details.sourceCatalog,
                templateId: this.templateId,
                quantity: item.quantity,
                uomLabel: item.uom_label
            });
        },
        async onSelectSupplier(supplierId) {
            try {
                let res = await this.$http.get(
                    `${process.env.CI_APPS}ajax/company/find_distributor?id=${supplierId}`
                );

                if (res.data && res.data.id) {
                    let distCode = res.data.distributor_code;
                    this.editDetails.sourceCatalog = distCode || null;
                }
            } catch (error) {
                console.log(error);
            }
        },
        async itemsSorted() {
            try {
                let itemOrder = {};

                for (let n = 0; n < this.items.length; n++) {
                    let id = this.items[n].id;
                    itemOrder[id] = n + 1;
                }

                await this.$http.post(
                    `${process.env.BARRAMUNDI}account/purchase-order-element-reorder`,
                    {
                        template_id: this.templateId,
                        order: itemOrder
                    }
                );
            } catch (error) {
                console.log(error);
            }
        },
        getUOM(code) {
            let references = this.$store.state.references;
            if (references.uoms) {
                return references.uoms[code];
            } else {
                return null;
            }
        }
    }
};
</script>

<style scoped>
::v-deep .custom-flex .bv-no-focus-ring {
    display: flex;
    align-items: center;
}
.top {
    margin-top: 10px;
    margin-bottom: 3px;
}
</style>
